import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/hooks/translation';
import Checkbox from '@common/components/checkbox';
import { checkBoxFields } from '../constants/checkboxesFields';

export const RegistrationTermsAndConditions = ({
  form, setForm, errors,
}) => {
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value.target.checked });
  };
  const t = useTranslation();

  return (
    <div className="popup-register-wide-form">
      <div className="check-box">
        {
          checkBoxFields.map((item) => (
            <Checkbox
              key={item}
              onChange={(value) => onChange(item.name, value)}
              name={item.fieldName}
              checked={form[item.name]}
              id={item.fieldName}
              label={(
                <label className="check-box-label" htmlFor={item.fieldName}>
                  <span>{t(item.label)}</span>
                  <span className="error-message">
                    {t(errors[item.name])}
                  </span>
                </label>
              )}
            />
          ))
        }
      </div>

    </div>
  );
};

RegistrationTermsAndConditions.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  errors: PropTypes.object,
};
